import React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface INewPencilProps extends IconPropsType {}

const NewPencilIcon = ({
  size = 16,
  stroke = '#41435A',
  ...props
}: INewPencilProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.16663 14.1666C3.16663 7.99992 5.58329 1.83325 12.8333 1.83325C12.8333 4.57399 9.72615 6.62955 9.72615 6.62955L11.1071 7.65733C11.1071 7.65733 9.72615 12.111 3.66663 12.111"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="square"
    />
  </svg>
);

export default NewPencilIcon;
